var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPwShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_66_412",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.72745C11.132 8.72745 10.2996 9.07225 9.68583 9.68601C9.07208 10.2998 8.72727 11.1322 8.72727 12.0002C8.72727 12.8682 9.07208 13.7006 9.68583 14.3143C10.2996 14.9281 11.132 15.2729 12 15.2729C12.868 15.2729 13.7004 14.9281 14.3142 14.3143C14.9279 13.7006 15.2727 12.8682 15.2727 12.0002C15.2727 11.1322 14.9279 10.2998 14.3142 9.68601C13.7004 9.07225 12.868 8.72745 12 8.72745ZM12 17.4547C10.5534 17.4547 9.16598 16.88 8.14305 15.8571C7.12013 14.8342 6.54545 13.4468 6.54545 12.0002C6.54545 10.5535 7.12013 9.16616 8.14305 8.14323C9.16598 7.12031 10.5534 6.54563 12 6.54563C13.4466 6.54563 14.834 7.12031 15.8569 8.14323C16.8799 9.16616 17.4545 10.5535 17.4545 12.0002C17.4545 13.4468 16.8799 14.8342 15.8569 15.8571C14.834 16.88 13.4466 17.4547 12 17.4547ZM12 3.81836C6.69818 3.81836 1.94182 7.09109 0 12.0002C2.60727 18.6329 10.0909 21.8838 16.7236 19.2765C20.0509 17.9674 22.6909 15.3384 24 12.0002C22.0582 7.09109 17.3018 3.81836 12 3.81836Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_66_412)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#ED3241"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwShow);
export default __webpack_public_path__ + "static/media/pwShow.652f36a3f87787a049bf3712005081a4.svg";
export { ForwardRef as ReactComponent };